import { Outlet } from 'react-router';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { MySorareLayout } from '@sorare/marketplace/src/components/mySorare/Layout';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const Layout = () => {
  return (
    <RequireAuth>
      <AppLayout>
        <MySorareLayout>
          <Outlet />
        </MySorareLayout>
      </AppLayout>
    </RequireAuth>
  );
};
export default Layout;
